class trackOrder extends HTMLElement {
  constructor() {
    super();
    this.orderInput = "[data-plant-input]";
    this.orderInputResults = "[data-plant-input-results]";
    this.orderInputWrapper = "[plant-input-wrapper]";
    this.submitBtn = "[data-plant-submit]";
    this.submitBtnTxt = "[data-track-order]";
    this.loader = "[data-loader]";
    this.shopBtn = "[data-plant-shop]";
    this.errorState = "[data-error-state]";
    this.resultState = "[data-plant-result]";
    this.plantBtnWrapper = '[data-plant-buttons]';
    this.imgEle = "[data-response-image]";  
    this.answerState = '[data-plant-field]';
    this.submitMap = '[data-map-submits';
    this.plantationDate = '[data-plantation-date]';
    this.plantName = '[data-plant-result-msg]';
    this.mapBtnForMobile = '[data-map-buttons]';
    this.plantStepFirst= '[data-plant-first-step]';
    this.plantStepSecond= '[data-plant-second-step]';
    this.mapButtonForMobile = '[data-map-hide-desktop]';
    this.form = ".track-your-plant-fields";
    this.init();
  }
  init() {
    this.querySelector(this.submitBtn).addEventListener(
      "click",
      this.trackOrder.bind(this)
    );    
    this.querySelector(this.form).addEventListener("submit", (e) => {
      e.preventDefault();
      this.querySelector(this.submitBtn).click();
      console.log('yesss');
    })
  }
  trackOrder() {
    let newDate = "";
    let orderIdPattern = "";
    this.querySelector(this.shopBtn).classList.add("hidden");
    this.querySelector(this.orderInputWrapper).classList.remove("track-your-plant-input-error"); 
    this.querySelector(this.errorState).classList.add("hidden");
    this.querySelector(this.submitBtn).classList.add("full-width");
    let inputValue = this.querySelector(this.orderInput).value;
    orderIdPattern = /^U\d+/;
    let matchVal = orderIdPattern.test(inputValue);

    if(this.querySelector(this.orderInput).value == '' || !matchVal) {      
      this.handleError(true);
    } else {      
      this.querySelector(this.submitBtn).querySelector(this.loader).classList.remove("hidden");            
      this.querySelector(this.submitBtn).querySelector(this.submitBtnTxt).classList.add("opaque"); 
      let requestBody = {
        order_number: inputValue,
        // order_number: "US-P#0007",
      };
      fetch(
        "https://i0bk99w95i.execute-api.ap-south-1.amazonaws.com/latest/orderdata",
        {
          body: JSON.stringify(requestBody),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {  
          let data = response.data;          
          var lng = data.latitude; // Assuming the API returns 'latitude'
          var lat = data.longitude; // and 'longitude'. Adjust these according to your API's response structure.         
          const newIframeSrc = `https://www.google.com/maps/embed/v1/place?key=AIzaSyDkzgbBZ_OkeBY-LkwjSpP_PTWfqrXbAt8&q=${lat},${lng}`; 
          let mapURL = `http://www.google.com/maps/place/${lat},${lng}`;
          newDate = this.formatDate(data.date);
          let plantOriginalMsg = this.querySelector(this.plantName).innerHTML.trim();         
          let plantMsg = plantOriginalMsg.replace('{plant name}', data.plantName);
          document.getElementById('googleMapIframe').src = newIframeSrc;     
          this.querySelectorAll(this.submitMap).forEach((btn) => {
            btn.setAttribute("href", mapURL);
          });          
          setTimeout(() => {
            this.querySelector(this.imgEle).src = data.imgUrl;
            this.querySelector(this.plantationDate).innerText = newDate;            
            this.querySelector(this.plantName).innerHTML = plantMsg;        
            this.querySelector(this.mapBtnForMobile).setAttribute("href", mapURL);
            this.querySelector(this.mapBtnForMobile).classList.remove("hidden");
            this.querySelector(this.plantStepFirst).classList.add("hidden");
            this.querySelector(this.plantStepSecond).classList.remove("hidden");
            this.querySelector(this.mapButtonForMobile).classList.remove("hidden");
            this.querySelector(this.plantStepSecond).querySelector(this.orderInputResults).value = "Order No. " + inputValue;
            this.handleError(false);
          }, 1000);             
        })
        .catch((error) => {
          console.log(error, 'error');
          this.handleError(true);
        });
    }
  }

  formatDate(dateVal) {
    const originalDate = dateVal;
    const dateParts = originalDate.split('/');

    const month = dateParts[0].padStart(2, '0');
    const day = dateParts[1].padStart(2, '0');
    const year = dateParts[2];

    const formattedDate = `${month}.${day}.${year}`;
    return formattedDate;

  }

  handleError(errorState) {
    if(errorState) {
      this.querySelector(this.errorState).classList.remove("hidden");
      this.querySelector(this.shopBtn).classList.remove("hidden");
      this.querySelector(this.submitBtn).querySelector(this.loader).classList.add("hidden");     
      this.querySelector(this.submitBtn).querySelector(this.submitBtnTxt).classList.remove("opaque");        
      this.querySelector(this.orderInputWrapper).classList.add("track-your-plant-input-error");
      this.querySelector(this.submitBtn).classList.remove("full-width");
    } else {
      this.querySelector(this.errorState).classList.add("hidden");
      this.querySelector(this.submitBtn).querySelector(this.loader).classList.add("hidden");            
      this.querySelector(this.submitBtn).querySelector(this.submitBtnTxt).classList.remove("opaque"); 
      this.querySelector(this.orderInputWrapper).classList.remove("track-your-plant-input-error");
      this.querySelector(this.submitBtn).classList.add("full-width");
    }
  }
  initMap(lat, lng) {
    // Show the map container
    document.getElementById("map").style.display = "block";
    var position = new google.maps.LatLng(lat, lng);
    var map = new google.maps.Map(document.getElementById("map"), {
      center: position,
      zoom: 8,
    });
    var marker = new google.maps.Marker({
      position: position,
      map: map,
    });
    console.log("yesss");
  }
}

customElements.define("track-order", trackOrder);
